export class TitleValue{
    name:string;
    data:number[];
    stack:string;
    constructor(name:string,data:number[],stack:string){
        this.name = name,
        this.data = data,
        this.stack = stack
    }
}